import { Pipe, PipeTransform } from '@angular/core';
import { Location } from '@angular/common';
import { PlatformInformationService } from '../services/platform-information.service';

@Pipe({
  name: 'platformurl'
})
export class PlatformurlPipe implements PipeTransform {
  constructor(private platformservice: PlatformInformationService) {}

  transform(relativeUrl: string, fromSSR = false): string {
    if (this.platformservice.getHostname() && relativeUrl) {
      return Location.joinWithSlash(
        fromSSR ? this.platformservice.getOrigin() : this.platformservice.getHostname(),
        encodeURI(relativeUrl)
      );
    }
  }
}
